const olaKKClubCodeList = [
  'Olakk', 'Flaresenha', 'lancebr', 'thalya', 'SuperRobJ4', 'mixrj', 'MundoPoker', 'gambitrose',
  'nbponline', 'rosegambit', '172866', 'tauasag', 'Caio', 'Melo'
]

// All club header banner path in caio, melo and others (default) club id
const imgMap = {
  caio: {
    bg: '/header/caio_headerBackground.jpg',
    src: '/header/caio_header.png',
    moibleHeader: '/caio_header_mobile.png',
    logoTitle: '/title/title_title_superStar.png',
    mobileTitle: '/static/img/mission/mobile_middle_superStar.png'
  },
  melo: {
    bg: '/header/melo_headerBackground.jpg',
    src: '/header/melo_header.png',
    moibleHeader: '/melo_header_mobile.png',
    logoTitle: '/title/title_title_superStar.png',
    mobileTitle: '/static/img/mission/mobile_middle_superStar.png'
  },
  default: {
    bg: '/header_banner.jpg',
    src: 'olakk_header_visual.png?v2',
    moibleHeader: 'olakk_mobile_header.jpg?v2'
    // logoTitle: '/title/title_title.png',
    // mobileTitle: '/static/img/mission/header_mb.jpg'
  }
}
// specific club id
// const specificList = ['caio', 'melo']
export const setClubBannerImage = (inviteCode) => {
  const newCode = 'default'
  // specificList.includes(inviteCode) ? inviteCode :
  return imgMap[newCode]
}

export const olaKKClubs = olaKKClubCodeList.map(x => x.toLocaleLowerCase())
